<div class="importer-page">

  <!-- Page Header -->
  <div class="importer-header">
    <div class="backButton" (click)="onBack()">
      <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
    </div>
    <div class="header-row">
      <div class="header-text">
        <p class="page-title">{{ 'Import Source' | translate }}</p>
        <p class="page-subtitle">{{ 'Select where your' | translate }} {{ importTypeLabel | translate }} {{ 'data is coming from.' | translate }}</p>
      </div>
      <div class="header-actions" *ngIf="importStep === 'form'">
        <button class="action-btn secondary" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
        <button
          class="action-btn primary"
          [class.disabled]="!canStartImport"
          [disabled]="!canStartImport"
          (click)="onStartImport()">
          {{ 'Start Import' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- ── STEP 1: Source Selection Cards ── -->
  <div class="source-grid" *ngIf="importStep === 'select'">
    <div
      class="source-card"
      *ngFor="let source of sources"
      [class.selected]="selectedSource === source.id"
      (click)="selectSource(source.id)">

      <div class="source-icon">
        <ng-container *ngIf="source.icon; else defaultIcon">
          <img [src]="source.icon" [alt]="source.name" class="source-logo" />
        </ng-container>
        <ng-template #defaultIcon>
          <img src="assets/icons/upload_gray.svg" [alt]="'CSV' | translate" class="csv-upload-icon csv-upload-gray" />
          <img src="assets/icons/upload_green.svg" [alt]="'CSV' | translate" class="csv-upload-icon csv-upload-green" />
        </ng-template>
      </div>

      <div class="source-info">
        <h4 class="source-name">{{ source.name | translate }}</h4>
        <p class="source-desc">{{ source.desc | translate }}</p>
      </div>
    </div>
  </div>

  <!-- ── STEP 2: Source Form ── -->
  <div class="source-section" *ngIf="importStep === 'form'">
    <div class="section-header">
      <h3 class="section-title">{{ sectionTitle | translate }}</h3>
    </div>

    <!-- CSV Upload Form -->
    <div class="section-body" *ngIf="selectedSource === 'csv'">
      <div class="csv-options-row">
        <p class="csv-hint">{{ 'you can use this when updating existing products to save time. Images will not be re-processed.' | translate }}</p>
        <label class="skip-label" (click)="skipImages = !skipImages">
          <div class="custom-check" [class.checked]="skipImages">
            <mat-icon *ngIf="skipImages">check</mat-icon>
          </div>
          <span>{{ 'Skip Images from file' | translate }}</span>
        </label>
      </div>

      <!-- Drop Zone -->
      <div
        class="drop-zone"
        [class.has-file]="csvFile"
        (click)="!csvFile && csvFileInput.click()">

        <ng-container *ngIf="!csvFile">
          <div class="upload-icon-circle">
            <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
              <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6.66667" />
              <path
                d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953"
                stroke="url(#paint0_linear_csv_upload)"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <defs>
                <linearGradient id="paint0_linear_csv_upload" x1="23.8178" y1="41.8996" x2="20.7349" y2="16.145" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#7CEEE6" />
                  <stop offset="0.495192" stop-color="#3A95B9" />
                  <stop offset="0.990385" stop-color="#004691" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <p class="drop-main-text">{{ 'click to Upload File' | translate }}</p>
          <p class="drop-sub-text">{{ 'CSV files only' | translate }}</p>
        </ng-container>

        <ng-container *ngIf="csvFile">
          <div class="file-row">
            <img src="assets/icons/csv_file.svg" alt="CSV" class="file-csv-icon" />
            <div class="file-details">
              <p class="file-name">{{ csvFileName }}</p>
              <p class="file-ready-text">{{ 'Uploading is finished' | translate }}</p>
            </div>
            <div class="file-row-actions">
              <button type="button" class="icon-action-btn" (click)="removeCsvFile($event)" title="Remove file">
                <img src="assets/icons/trash.svg" alt="delete" />
              </button>
              <button type="button" class="icon-action-btn" (click)="csvFileInput.click(); $event.stopPropagation()" title="Replace file">
                <img src="assets/icons/refresh.svg" alt="replace" />
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <input
        type="file"
        #csvFileInput
        accept=".csv"
        hidden
        (change)="onFileSelected($event)" />

      <!-- Sample CSV -->
      <div class="sample-row">
        <div>
          <p class="sample-title">{{ 'Need a starting point?' | translate }}</p>
          <p class="sample-desc">{{ 'Download our sample CSV file to ensure your data is formatted correctly for Stacks.' | translate }}</p>
        </div>
        <a class="download-link" href="javascript:void(0)">
          <img src="assets/icons/download_gradient.svg" alt="download" class="download-icon-img" />
          {{ 'Download sample CSV' | translate }}
        </a>
      </div>
    </div>

    <!-- Direct Source Form (WooCommerce / Odoo / Zoho) -->
    <div class="section-body direct-body" *ngIf="selectedSource !== 'csv'">
      <div class="direct-source-info">
        <img
          *ngIf="selectedSourceData?.icon"
          [src]="selectedSourceData?.icon"
          [alt]="selectedSourceData?.name"
          class="direct-logo" />
        <p class="direct-desc">
          {{ 'Click' | translate }} "<strong>{{ 'Start Import' | translate }}</strong>" {{ 'to sync your' | translate }}
          {{ importTypeLabel | translate }} {{ 'from' | translate }} {{ selectedSourceData?.name }}.
        </p>
      </div>
    </div>
  </div>

  <!-- ── STEP 3: Importing in Progress ── -->
  <div class="source-section" *ngIf="importStep === 'importing'">
    <div class="section-header">
      <h3 class="section-title">{{ sectionTitle | translate }}</h3>
    </div>
    <div class="section-body progress-body">
      <div class="gradient-spinner"></div>
      <p class="progress-title">{{ progressMessage | translate }}</p>
      <p class="progress-hint">{{ 'please don\'t close this window' | translate }}</p>
    </div>
  </div>

  <!-- ── STEP 4: Success ── -->
  <div class="source-section" *ngIf="importStep === 'success'">
    <div class="section-header">
      <h3 class="section-title">{{ sectionTitle | translate }}</h3>
    </div>
    <div class="section-body success-body">
      <div class="success-icon-wrapper">
        <img src="assets/icons/import_check.svg" alt="success" class="success-icon" />
      </div>
      <p class="success-title">{{ successViewLabel | translate }} {{ 'imported successfully.' | translate }}</p>
      <p class="success-desc">{{ 'Your existing' | translate }} {{ importTypeLabel | lowercase }} {{ 'have been replaced with the new data from' | translate }} {{ selectedSourceData?.name }}.</p>

      <div class="corrupted-images" *ngIf="corruptedImages?.length">
        <p class="corrupted-label">{{ 'The following images could not be processed:' | translate }}</p>
        <ul>
          <li *ngFor="let img of corruptedImages">{{ img }}</li>
        </ul>
      </div>

      <button class="action-btn primary view-btn" (click)="onViewResults()">
        {{ 'View' | translate }} {{ successViewLabel | translate }}
      </button>
    </div>
  </div>

</div>

<!-- ── Warning Modal ── -->
<div class="warning-overlay" *ngIf="showWarningModal" (click)="onCancelWarning()">
  <div class="warning-modal" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="onCancelWarning()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M1 1L13 13M13 1L1 13" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>

    <div class="modal-icon">
      <img src="assets/icons/warning.svg" alt="warning" class="modal-warning-icon" />
    </div>

    <h3 class="modal-title">{{ 'Important Warning' | translate }}</h3>
    <p class="modal-message">
      {{ 'Importing' | translate }} {{ importTypeLabel | lowercase }}
      {{ 'will replace your existing data in this channel.' | translate }}
    </p>

    <button class="modal-continue-btn" (click)="onConfirmImport()">
      {{ 'Continue' | translate }}
    </button>
    <button class="modal-cancel-text" (click)="onCancelWarning()">
      {{ 'Cancel' | translate }}
    </button>
  </div>
</div>
